import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/visitedProfileActions";
export const visitedProfileSlicer = createSlice({
  name: "visitedProfile",
  initialState: {
    data: null,
    posts: null,
    replies: null,
    loading: false,
    error: null,
  },
  extraReducers: {
    [action.getVisitedProfile.pending]: (state) => {
      state.loading = true;
    },

    [action.getVisitedProfile.fulfilled]: (state, action) => {
      const { data, status } = action.payload;
      if (status === 200) {
        state.loading = false;
        state.data = data;
      } else {
        state.loading = false;
        state.error = data;
      }
    },
    [action.followVisitedProfile.fulfilled]: (state, action) => {
      const { data, status } = action.payload;
      if (status === 200) {
        state.data = data;
      } else {
        state.error = data;
      }
    },
    [action.unFollowVisitedProfile.fulfilled]: (state, action) => {
      const { data, status } = action.payload;
      if (status === 200) {
        state.data = data;
      } else {
        state.error = data;
      }
    },
    [action.getProfilePosts.fulfilled]: (state, action) => {
      const { data, status } = action.payload;
      if (status === 200) {
        state.posts = data;
      } else {
        state.error = data;
      }
    },
    [action.getProfileReplies.fulfilled]: (state, action) => {
      const { data, status } = action.payload;
      if (status === 200) {
        state.replies = data;
      } else {
        state.error = data;
      }
    },
    [action.suspendVisitedProfile.fulfilled]: (state, action) => {
      const { suspended } = action.payload.data;
      const { status } = action.payload;
      if (status === 200) {
        state.data.suspended = suspended;
      }
    },
  },
});

export default visitedProfileSlicer.reducer;

